module.exports = __webpack_public_path__ + "static/layertree-7200c981e54d971e64ebd56b41bb4983.png";